import React from 'react';
import { CircularProgress } from '@mui/material';
import {
  AttentionBoxWithIcon,
  Button,
  DialogContentText,
  Modal,
  TableTextGroup
} from '@p81-common/ui';

import type { FeatureFlagRow } from '../helpers/types';
import classes from './ConfirmModals.module.scss';

interface AssignConfirmModalProps {
  open: boolean;
  flags: FeatureFlagRow[];
  region: string;
  onApprove: () => void;
  onBack: () => void;
  isLoading?: boolean;
}

const AssignConfirmModal = ({
  open,
  flags,
  region,
  onApprove,
  onBack,
  isLoading = false
}: AssignConfirmModalProps) => (
  <Modal
    id="assignFeatureFlagsModal"
    open={open}
    onClose={onBack}
    dialogTitleProps={{
      children: `Assign ${flags.length} feature ${
        flags.length === 1 ? 'flag' : 'flags'
      }`
    }}
    dialogContentProps={{
      className: classes.content,
      children: (
        <>
          <DialogContentText>
            {`These flags will be turned on for this tenant in the ${region} region.`}
          </DialogContentText>

          {/* Listed in the order the table shows them, so the summary can be
              checked against what was ticked. */}
          <ul className={classes.list}>
            {flags.map(flag => (
              <li key={flag._id} className={classes.item}>
                <TableTextGroup
                  title={flag.name}
                  subtitle={flag.description || flag.ffKey}
                />
              </li>
            ))}
          </ul>

          {/* content takes a ReactNode, so the two clauses get their own
              lines rather than wrapping wherever the box happens to end. */}
          <AttentionBoxWithIcon
            content={
              <>
                Takes effect immediately for this tenant.
                <br />
                The change is recorded in the Activity Log.
              </>
            }
          />
        </>
      )
    }}
    dialogActionsProps={{
      children: (
        <>
          {/* A step back, not a cancel — the selection survives. */}
          <Button
            variant="text"
            color="primary"
            onClick={onBack}
            disabled={isLoading}
          >
            Back
          </Button>
          <Button
            onClick={onApprove}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={16} /> : undefined}
          >
            Approve Assign
          </Button>
        </>
      )
    }}
  />
);

export default AssignConfirmModal;
